import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { _get, _getloader, _post } from "../../Config/axiosInstance";

function OTPAuthPage() {
  const navigate = useNavigate();
  const location = useLocation();
  console.log("location.state", location.state);
  // Destructure data passed from NewTicketBooking
  const { phoneNumber, verificationId, ...bookingData } = location.state || {};

  const [otp, setOtp] = useState("");
  const [verified, setVerified] = useState(false);
  const [loading, setLoading] = useState(false);

  // Unified snackbar state
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
    varient: "filled",
  });

  const handleVerifyOTP = async () => {
    if (!otp || !verificationId || !phoneNumber) {
      setSnackbar({
        open: true,
        message: "Missing OTP or verification details.",
        severity: "error",
      });
      return;
    }

    try {
      setLoading(true);
      // const response = await _get(
      //   `/verifyOTP/${phoneNumber}/${verificationId}/${otp}`
      // );

      // if (response.data?.data?.responseCode === 200) {
      //   setVerified(true);
      //   setSnackbar({
      //     open: true,
      //     message: "OTP Verified Successfully!",
      //     severity: "success",
      //   });
      console.log("first");
      if (true) {
        setVerified(true);
        setSnackbar({
          open: true,
          message: "OTP Verified Successfully!",
          severity: "success",
        });

        const finalPayload = {
          ...bookingData,
          phoneNumber,
        };

        try {
          await _post(`bookticket`, finalPayload);
          // Navigate after a short delay to allow snackbar to be visible
          setTimeout(() => {
            navigate("/bookings", { state: finalPayload });
          }, 2000);
        } catch (error) {
          console.error("Booking error:", error);
          setSnackbar({
            open: true,
            message: "Failed to complete booking. Please try again.",
            severity: "error",
          });
        }
      } else {
        setSnackbar({
          open: true,
          message: "OTP verification failed.",
          severity: "error",
        });
      }
    } catch (error) {
      console.error("OTP verification error:", error);
      setSnackbar({
        open: true,
        message: "Error verifying OTP. Please try again.",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  if (loading) {
    return _getloader();
  }

  return (
    <Box
      sx={{
        maxWidth: 400,
        mx: "auto",
        mt: 5,
        p: 3,
        boxShadow: 3,
        borderRadius: 2,
      }}
    >
      <Typography variant="h5" gutterBottom>
        OTP Verification
      </Typography>

      {!verified ? (
        <>
          <Typography variant="body1" gutterBottom>
            A verification code has been sent to <strong>{phoneNumber}</strong>
          </Typography>

          <TextField
            fullWidth
            label="Enter OTP"
            placeholder="e.g. 123456"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            margin="normal"
          />
          <Button
            variant="contained"
            color="success"
            fullWidth
            onClick={handleVerifyOTP}
          >
            Verify OTP
          </Button>
        </>
      ) : (
        <Typography variant="body1" color="green" mt={2}>
          ✅ Phone number verified! Your booking has been booked successfully.
        </Typography>
      )}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          variant={snackbar.varient}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default OTPAuthPage;
